import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Banner from '../components/others/Banner'
import About from '../pages/About'
import Contact from '../pages/Contact'
import Home from '../pages/Home'
import Portfolio from '../pages/Portfolio'
import PortfolioDetails from '../pages/PortfolioDetails'

const AppRouter = () => {
  return (
    <>
    <BrowserRouter>
    <Header/>
    <Routes>
        <Route path='/' element={<Home/>}></Route>
        <Route path='/about' element={<About/>}></Route>
        <Route path='/contact' element={<Contact/>}></Route>
        <Route path='/portfolio' element={<Portfolio/>}></Route>
        <Route path='/:title' element={<PortfolioDetails/>}></Route>
    </Routes>
    <Footer/>
    <Banner/>
    </BrowserRouter>
    
    </>
  )
}

export default AppRouter
